import type { AssetRopaReview, AssetRopaWarningFlags, RopaReviewRoundStatus } from 'config/api/ropaReviews/ropaReviews.types';

export type BulkAcceptBlockReason =
  | 'dpia_indicated'
  | 'dpia_required_unapproved'
  | 'third_country_processing'
  | 'sensitive_personal_data'
  | 'clarification_requested'
  | 'no_submitted_reviews';

export const isReviewLocked = (status: RopaReviewRoundStatus): boolean => status === 'completed' || status === 'cancelled';

export const hasAssetWarnings = (warnings: AssetRopaWarningFlags): boolean =>
  warnings.dpiaIndicated ||
  warnings.dpiaRequiredUnapproved ||
  warnings.thirdCountryProcessing ||
  warnings.sensitivePersonalData ||
  warnings.confirmedNoProcessingActivities;

export const getSubmittedReviewCount = (asset: AssetRopaReview): number =>
  asset.processingActivityReviews.filter(row => row.reviewStatus === 'submitted').length;

export const getBulkAcceptBlockReasons = (asset: AssetRopaReview): BulkAcceptBlockReason[] => {
  const reasons: BulkAcceptBlockReason[] = [];
  const { warnings, processingActivityReviews } = asset;

  if (warnings.dpiaIndicated) reasons.push('dpia_indicated');
  if (warnings.dpiaRequiredUnapproved) reasons.push('dpia_required_unapproved');
  if (warnings.thirdCountryProcessing) reasons.push('third_country_processing');
  if (warnings.sensitivePersonalData) reasons.push('sensitive_personal_data');

  if (processingActivityReviews.some(row => row.reviewStatus === 'clarification_requested')) {
    reasons.push('clarification_requested');
  }

  if (getSubmittedReviewCount(asset) === 0) {
    reasons.push('no_submitted_reviews');
  }

  return reasons;
};

export const canBulkAcceptSubmittedReviews = (asset: AssetRopaReview): boolean => getBulkAcceptBlockReasons(asset).length === 0;
